<div class="payments-card-container">
  <ion-card class="payments-card">
    <ion-card-header>
      <ion-card-title data-cy="account-balance-title">{{
        'i18n.payments.accountBalance.title' | translate
      }}</ion-card-title>
      <ion-button
        *ngIf="customers?.length > 1"
        class="usf-outline-green-button usf-outline-green-button-left-aligned"
        (click)="openCustomerSelectionPopover($event)"
        data-cy="open-customer-dropdown-btn"
      >
        <span
          *ngIf="selectedCustomer"
          class="usf-outline-green-button-left-content"
        >
          <span
            class="usf-outline-green-button-text"
            data-cy="selected-customer-information"
          >
            <span class="customer-info-text">{{
              customerSelectorLabel | titlecase
            }}</span>
            <span
              class="customer-number"
              *ngIf="
                selectedCustomer.length === 1 &&
                !!selectedCustomer[0].customerNumber
              "
            >
              &nbsp;{{ '(' + selectedCustomer[0].customerNumber + ')' }}
            </span>
          </span>
        </span>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-card-header>
    <ion-card-content>
      <ng-container *ngIf="!accountSummaryState?.loading; else showSpinner">
        <p
          class="payments-card-content-title"
          data-cy="account-summary-total-balance"
        >
          <span class="account-balance">{{
            (accountSummaryState?.totalBalance
              ? accountSummaryState?.totalBalance
              : 0
            ) | currency
          }}</span>
        </p>
        <p
          class="payments-card-content"
          data-cy="account-summary-overdue-balance"
        >
          {{ 'i18n.payments.accountBalance.overdueBalance' | translate }}
          <span class="color-secondary">{{
            (accountSummaryState?.totalBalanceDue
              ? accountSummaryState?.totalBalanceDue
              : 0
            ) | currency
          }}</span>
        </p>
      </ng-container>
      <ng-template #showSpinner>
        <ion-spinner name="circles" class="spinner"></ion-spinner>
      </ng-template>
      <div class="buttons-group">
        <ng-container
          *ngIf="showMakePayments || (!showMakePayments && !isSuperUser)"
        >
          <ion-button
            *ngIf="
              enablePayBalanceButton && accountSummaryState?.totalBalance > 0
            "
            class="usf-fill-green-button"
            data-cy="pay-account-balance-btn"
            (click)="onPayBalanceClick()"
          >
            {{ 'i18n.payments.accountBalance.payBalanceButton' | translate }}
            <ion-icon
              *ngIf="!showMakePayments"
              src="assets/icon/external-link-white.svg"
            ></ion-icon>
          </ion-button>
        </ng-container>
        <ion-button
          class="usf-outline-green-button"
          (click)="goToAllInvoices()"
          data-cy="go-to-all-invoices-btn"
        >
          {{ 'i18n.payments.accountBalance.viewInvoicesButton' | translate }}
        </ion-button>
      </div>
    </ion-card-content>
  </ion-card>
</div>
